import { render, staticRenderFns } from "./ClaimAccountTerms.vue?vue&type=template&id=f00f7616&scoped=true"
import script from "./ClaimAccountTerms.vue?vue&type=script&lang=ts"
export * from "./ClaimAccountTerms.vue?vue&type=script&lang=ts"
import style0 from "./ClaimAccountTerms.vue?vue&type=style&index=0&id=f00f7616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00f7616",
  null
  
)

export default component.exports